import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TERRITORY_NICHES_BRANDED_VS_UGC_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-niches-branded-vs-ugc',
  name: 'Get territory niches branded vs UGC',
  message: 'Failed to get territory niches branded vs UGC metrics',
}

export const EMPTY_METRICS = {
  totalPosts: 0,
  totalEngagement: 0,
  totalViews: 0,
  avgEngagement: 0,
  avgViews: 0,
}
